import { decode } from 'url-safe-base64';

/**
 * @returns When the token expires, in milliseconds since the epoch; null when it has no
 * readable `exp` claim
 */
export const getJwtExpiresAt = (token: string): number | null => {
  try {
    const payload = JSON.parse(atob(decode(token.split('.')[1] ?? '')));
    return typeof payload?.exp === 'number' ? payload.exp * 1000 : null;
  } catch {
    return null;
  }
};
